import { formatMoney, stringToNumber } from "./formatter";

export const changeData = (value, id, setData, setCredit, data, credit) => {
  if (id === "area") {
    setData({
      ...data,
      area: value,
    });
  }
  if (data.entryType !== "credits") {
    if (id === "monto") {
      setData({
        ...data,
        amount: value === 0 ? "" : formatMoney(value, data.currency),
      });
    }
    if (id === "date") {
      setData({
        ...data,
        date: value,
      });
    }
    if (id === "repeat") {
      setData({
        ...data,
        repeat: value,
      });
    }
    if (id === "finalDate") {
      setData({
        ...data,
        finalDate: value,
      });
    }
    if (id === "pay") {
      setData({
        ...data,
        pay: value,
      });
    }
  } else if (data.entryType === "credits") {
    if (id === "creditType") {
      setCredit({
        ...credit,
        creditType: value,
      });
    }
    if (id === "banks") {
      setCredit({
        ...credit,
        bank: value,
      });
    }
    if (id === "identificator") {
      setCredit({
        ...credit,
        id: value,
      });
    }
    if (id === "monto") {
      setCredit({
        ...credit,
        liquidAmount: value === 0 ? "" : formatMoney(value, data.currency),
      });
    }
    if (id === "paymentsAmount") {
      setCredit({
        ...credit,
        paymentsAmount: value === 0 ? "" : formatMoney(value, data.currency),
      });
    }
    if (id === "payments") {
      setCredit({
        ...credit,
        payments: value === 0 ? "" : stringToNumber(value),
      });
    }
    if (id === "fees") {
      setCredit({
        ...credit,
        fees: value === 0 ? "" : stringToNumber(value),
      });
    }
    if (id === "feesPeriod") {
      setCredit({
        ...credit,
        feesPeriod: value,
      });
    }
    if (id === "date") {
      setCredit({
        ...credit,
        firstDate: value,
      });
    }
    if (id === "finalDate") {
      setCredit({
        ...credit,
        finalDate: value,
      });
    }
  }
};
